import React from 'react';
import _ from 'underscore';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Order, Manifest } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  DetailSender,
  DetailOrder,
  DetailPayment,
  Do,
  MapTrucking,
  PaymentList,
  Log,
  Document
} from './component/section';
import { ContactInformation } from '../shipment/component/detail';
import ManifestTrucking from './component/section/manifest.trucking';

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const Session = useSelector((state) => state.Auth?.session);

  const [data, setData] = React.useState(null);
  const [count, setCount] = React.useState(null);
  const [legs, setLegs] = React.useState(null);
  const [manifestTrucking, setManifestTrucking] = React.useState(null);
  const [privilege, setPrivilege] = React.useState(null);

  const $onLoad = async (id) => {
    const req = await Dispatch(Order.$show(id));

    if (req?.message === 'success') {
      if (req?.data?.shipment_count?.total === 0) {
        History.push('/order');
      }

      let order = req?.data
      convertToLegs(order);
    }
  };

  const $getPriviledge = async () => {
    const payload = {};

    const delivery = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.delivery',
    });

    const manifest = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });

    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    if (pricing) {
      payload.pricing = pricing;
    }

    if (delivery) {
      payload.delivery = delivery;
    }

    if (manifest) {
      payload.manifest = manifest;
    }

    setPrivilege(payload);
  };

  const $onLoadManifestTrucking = async (id) => {
    const req = await Dispatch(Manifest.$getByOrder(id));

    if (req?.message === 'success' && req?.data) {
      setManifestTrucking(req?.data[0]);
    }
  };

  const convertToLegs = async (data) => {
    // data?.delivery_orders?.forEach((d, i) =>
    //   console.log(
    //     `${d?.type} > ${d?.shipment?.origin?.name} - ${d?.shipment?.destination?.name}`
    //   )
    // );

    if (data?.type === 'ftl') {
      let chain = [];
      let legs = [];
      let pp = [];
      let dp = [];

      let mapping = [];

      data?.delivery_orders?.forEach((el, i) => {
        mapping.push({
          pickup: el?.shipment?.origin,
          destination: el?.shipment?.destination,
          type: el?.type,
        });
      });

      // const ppx = _.groupBy(
      //   data?.delivery_orders,
      //   (el, i) => el?.shipment?.origin?.id
      // );

      data?.delivery_orders?.forEach((el, i) => {
        if (el?.type === 'pickup' || el?.type === 'drop_point') {
          const oexist = _.findWhere(pp, {
            location_id: el?.shipment?.origin?.id,
          });

          if (!oexist) {
            pp.push({
              delivery_order: el,
              location_id: el?.shipment?.origin?.id,
              type: 'pickup',
              location: el?.shipment?.origin,
            });
          }

          const dexist = _.findWhere(dp, {
            location_id: el?.shipment?.destination?.id,
            type: 'drop_point',
          });

          if (!dexist) {
            dp.push({
              delivery_order: el,
              type: 'drop_point',
              location_id: el?.shipment?.destination?.id,
              location: el?.shipment?.destination,
            });
          }
        } else {
          chain.push({
            delivery_order: el,
            type: 'pickup',
            location_id: el?.shipment?.origin?.id,
            location: el?.shipment?.origin,
          });

          chain.push({
            delivery_order: el,
            type: 'drop_point',
            location_id: el?.shipment?.destination?.id,
            location: el?.shipment?.destination,
          });
        }
      });

      legs = [...pp, ...dp, ...chain];

      setLegs(legs);
    }

    setData(data);
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, [match]);

  React.useEffect(() => {
    if (
      data?.type === 'ftl' &&
      (!Session?.privileges || privilege?.manifest)
    ) {
      $onLoadManifestTrucking(data?.id);
    }
  }, [data, privilege]);

  return (
    <Page className="col-lg-11 col-md-11 bordered">
      <Page.Header
        pretitle="Order"
        title={data?.code}
        status={data?.document_status}
        backTo="/order"
      >
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Header>

      <Page.Body className="bg-white border-top padding mt-3 mt-md-0">
        <div className="row">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-6">
                <DetailOrder
                  data={data}
                  privilege={!Session?.privileges || privilege?.pricing}
                />
              </div>
              <div className="col-md-6">
                <DetailSender data={data} truckingCount={count} />
              </div>

              <div className="col-md-6">
                <DetailPayment
                  data={data}
                  privilege={!Session?.privileges || privilege?.pricing}
                />
              </div>

              {data?.pickup_address &&
                data?.type === 'ltl' && (
                  <div className="col-md-6">
                    <ContactInformation
                      title="Alamat Pickup"
                      data={data?.pickup_address}
                    />
                  </div>
                )}
            </div>

            {data?.type === 'ftl' ? (
              manifestTrucking ? (
                <ManifestTrucking
                  id={manifestTrucking?.id}
                  reloadOrder={() => {
                    $onLoad(match?.params?.id);
                    setManifestTrucking(null);
                  }}
                  setCount={(e) => {
                    setCount(e);
                  }}
                />
              ) : (
                <MapTrucking data={legs} />
              )
            ) : (
              <Do
                data={data}
                onSubmit={() => {
                  if (data?.delivery_orders?.length === 1) {
                    History.push('/order');
                  } else {
                    $onLoad(match?.params?.id);
                  }
                }}
              />
            )}
          </div>
          <div className="border-start border-sm-none col-md-3 mt-3 mt-md-0">
            {Session?.client?.company_type === 'carrier' &&
              (!Session?.privileges || privilege?.pricing) && (
                <PaymentList
                  order={data}
                  onSubmit={() => $onLoad(match?.params?.id)}
                  privilege={
                    !Session?.privileges ||
                    privilege?.delivery?.action === 'manage'
                  }
                />
              )}

            {data?.type === 'ftl' &&
              manifestTrucking && (
                <>
                  <Document id={data?.id} status={data?.document_status} />
                  <Log code={manifestTrucking?.id} />
                </>
              )}
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
